import { PurchasesYear } from '../../../models/analytics/analytics.model';
import { useGet } from '../../useApi';

// GET /admin/analytics/purchases?year=
const usePurchasesAnalytics = () => {
  const { data, loading, fetch } = useGet<PurchasesYear>('Failed to load purchases');
  return { purchases: data, loading, fetchPurchases: (year: number) => fetch('api/v1/admin/analytics/purchases', { year }) };
};

export default usePurchasesAnalytics;
